import React, { Component } from "react";
import stl from "./index.module.scss";

class index extends Component {
	render() {
		return (
			<>
				
				<div id={stl.iconWrapper}>
					<div className={stl.iconContainer}>
						<span className={stl.title}>잘못된 요청입니다.</span>
					</div>
				</div>
			</>
		);
	}
}

export default index;
